/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDocumentUploadUrlRequest
 */
export interface CreateDocumentUploadUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentUploadUrlRequest
     */
    document_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentUploadUrlRequest
     */
    file_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentUploadUrlRequest
     */
    content_type: string;
}

/**
 * Check if a given object implements the CreateDocumentUploadUrlRequest interface.
 */
export function instanceOfCreateDocumentUploadUrlRequest(value: object): value is CreateDocumentUploadUrlRequest {
    if (!('document_id' in value) || value['document_id'] === undefined) return false;
    if (!('file_name' in value) || value['file_name'] === undefined) return false;
    if (!('content_type' in value) || value['content_type'] === undefined) return false;
    return true;
}

export function CreateDocumentUploadUrlRequestFromJSON(json: any): CreateDocumentUploadUrlRequest {
    return CreateDocumentUploadUrlRequestFromJSONTyped(json, false);
}

export function CreateDocumentUploadUrlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDocumentUploadUrlRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'document_id': json['document_id'],
        'file_name': json['file_name'],
        'content_type': json['content_type'],
    };
}

export function CreateDocumentUploadUrlRequestToJSON(json: any): CreateDocumentUploadUrlRequest {
    return CreateDocumentUploadUrlRequestToJSONTyped(json, false);
}

export function CreateDocumentUploadUrlRequestToJSONTyped(value?: CreateDocumentUploadUrlRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'document_id': value['document_id'],
        'file_name': value['file_name'],
        'content_type': value['content_type'],
    };
}

